import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/utils/diagram/diagramPatchQueueHmr';
import App from './App';
import {ThemeProvider} from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<ThemeProvider>
		<App />
	</ThemeProvider>
);
